// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"64c19694","455":"777f1660","977":"a835eef4"}[chunkId] + ".chunk.js";
};